// @flow
import React from 'react';
import Snackbar from 'material-ui/Snackbar';
import Sound from 'react-sound';

export default ({ visible, message, playSound, hideErrorMessage }) => (
  <React.Fragment>
    {playSound && (
      <Sound url="/assets/notification.mp3" playStatus={Sound.status.PLAYING} />
    )}
    <Snackbar
      open={visible}
      autoHideDuration={3000}
      message={message || ''}
      onRequestClose={() => hideErrorMessage()}
    />
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./components/ErrorMessage/ErrorMessage.js